module.exports = __webpack_public_path__ + "static/img/1.050d924.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/1.png
// module id = kaWQ
// module chunks = 0